import 'bootstrap/js/dist/tooltip'

export function emojiTooltip() {
    $('.emoji-wrapper span').hover(function (e){
        const $this = $(this);
        let cl = 'apply-tooltip';

        const tpl = `<div class="tooltip ${cl}" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>`;

        $this.tooltip({
            template: tpl
        });
    })
}